import CustomTextField from "components/Input/CustomTextField";
import React from "react";
import { IconButton, InputAdornment } from "@material-ui/core";
import styled from 'styled-components/macro';
import SendIcon from '@material-ui/icons/Send';

const SInputCommentContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 15px;
`;

const SUserIcon = styled.div`
    border-radius: 50%;
    width: 30px;
    height: 30px;
    background-color: #55ca38;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    flex-shrink: 0;
`;

const InputComment = ({
    comment,
    onChangeComment,
    onSubmit,
    user, 
    submitIcon,
    placeholder
}) => {

    return (
        <SInputCommentContainer>
            {!!user && (
                <SUserIcon>
                    {user.detail.firstName.charAt(0).toUpperCase()}
                </SUserIcon>
            )}
            <CustomTextField
                value={comment}
                onChange={onChangeComment}
                placeholder
                isTextArea
                InputProps={{
                    endAdornment: (
                            <IconButton style={{ padding: 0 }} onClick={onSubmit}>
                                {submitIcon}
                            </IconButton>
                    )
                }}
            />
        </SInputCommentContainer>
    );
};
export default InputComment;